import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "@/contexts/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const STATUS_STYLE = {
  pending: "border-yellow-700 text-yellow-400",
  shipped: "border-green-700 text-green-400",
  cancelled: "border-red-700 text-red-400",
};

export default function MyOrders() {
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!user) return;
    axios.get(`${API}/shop/orders/me`, { withCredentials: true })
      .then((r) => setOrders(r.data.orders || []))
      .catch(() => setOrders([]));
  }, [user]);

  if (!user || orders.length === 0) return null;

  return (
    <div
      data-testid="my-orders"
      className="bg-[#0F0F0F] border border-zinc-900 mt-6"
    >
      <button
        onClick={() => setOpen(!open)}
        className="w-full p-5 text-left flex items-center justify-between hover:bg-[#0A0A0A] transition-colors"
      >
        <div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] font-bold">
            My Shop Orders
          </div>
          <h2 className="font-display text-xl text-white">
            {orders.length} order{orders.length === 1 ? "" : "s"}
          </h2>
        </div>
        <span className="text-neutral-500 text-2xl">{open ? "−" : "+"}</span>
      </button>
      {open && (
        <ul className="divide-y divide-zinc-900 border-t border-zinc-900">
          {orders.map((o) => (
            <li key={o.order_id} data-testid={`order-${o.order_id}`} className="p-4">
              <div className="flex justify-between items-start gap-3 mb-2">
                <div className="min-w-0">
                  <div className="text-xs font-mono text-neutral-500">
                    {o.order_id.slice(0, 16)}…
                  </div>
                  <div className="text-sm text-white">
                    {o.items.map((i) => `${i.image} ${i.name}×${i.qty}`).join(" · ")}
                  </div>
                </div>
                <div className="text-right flex-shrink-0">
                  <div className="font-mono tabular-nums font-bold text-[#D4AF37]">
                    {o.total_od} OD
                  </div>
                  <div
                    className={`text-[9px] uppercase tracking-widest font-bold border px-1.5 py-0.5 mt-1 inline-block ${
                      STATUS_STYLE[o.status] || "border-zinc-700 text-neutral-400"
                    }`}
                  >
                    {o.status}
                  </div>
                </div>
              </div>
              {o.tracking_number && (
                <div className="text-[10px] uppercase tracking-widest text-green-400">
                  Tracking: <span className="font-mono">{o.tracking_number}</span>
                </div>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
